import { DEFAULT_THEME_BACKGROUND_TYPE, isThemeBackgroundType } from '../../../../types/themeBackgroundTypes';
import { DEFAULT_THEME_TABLE_TYPE, isThemeTableType } from '../../../../types/themeTableTypes';
import { isThemeType } from '../../../../types/themeTypes';
import { encodedStringParser } from '../../inboundParsers';
import { splitWithBraces, trimBraces } from '../../inboundUtils';
export function themeSetParser(str) {
    // start with a valid default theme set and override with any valid properties that can be parsed:
    const themeSet = {
        default: {
            themeBackgroundType: DEFAULT_THEME_BACKGROUND_TYPE,
            themeTableType: DEFAULT_THEME_TABLE_TYPE
        },
        tourney: {
            themeBackgroundType: DEFAULT_THEME_BACKGROUND_TYPE,
            themeTableType: DEFAULT_THEME_TABLE_TYPE
        }
    };
    if (!str) {
        return themeSet;
    }
    const themePropertiesStrings = splitWithBraces(trimBraces(str));
    themePropertiesStrings.forEach((themePropertiesString) => {
        if (!themePropertiesString) {
            return;
        }
        const [themeType, encodedThemeBackgroundType, encodedThemeTableType] = trimBraces(themePropertiesString).split(',');
        const themeBackgroundType = encodedStringParser(encodedThemeBackgroundType);
        const themeTableType = encodedStringParser(encodedThemeTableType);
        if (isThemeType(themeType)) {
            themeSet[themeType] = {
                themeBackgroundType: isThemeBackgroundType(themeBackgroundType)
                    ? themeBackgroundType
                    : DEFAULT_THEME_BACKGROUND_TYPE,
                themeTableType: isThemeTableType(themeTableType) ? themeTableType : DEFAULT_THEME_TABLE_TYPE
            };
        }
    });
    return themeSet;
}
